import bcrypt from 'bcryptjs'
import { navigate } from 'gatsby'

export const isBrowser = () => typeof window !== 'undefined'

export const getUser = () =>
  isBrowser() && window.localStorage.getItem('emmausUser')
    ? JSON.parse(window.localStorage.getItem('emmausUser'))
    : {}

const setUser = user => window.localStorage.setItem('emmausUser', JSON.stringify(user))
const clearFriendlyForwardPath = () => window.localStorage.removeItem('friendlyForwardPath')
const getFriendlyForwardPath = () => window.localStorage.getItem('friendlyForwardPath')

export const handleLogin = async ({ username, password }) => {
  const usernameRegex = new RegExp(`^${process.env.GATSBY_USERNAME}$`, 'i')

  // Check username and password input
  if (
    username.trim().match(usernameRegex) &&
    (await bcrypt.compare(password, process.env.GATSBY_PASSWORD_HASH))
  ) {
    // Get friendly forward path from ls if exists
    const friendlyForwardPath = getFriendlyForwardPath()

    clearFriendlyForwardPath()

    setUser({
      username: 'emmausUser'
    })

    // Forward to friendlyForwardPath if exists, else navigate to '/'
    if (friendlyForwardPath) {
      return navigate(friendlyForwardPath)
    }

    navigate('/')
  }
  return 'Wrong username or password.'
}

export const isLoggedIn = () => {
  const user = getUser()

  return !!user.username
}

export const logout = () => {
  setUser({})
  clearFriendlyForwardPath()
  navigate('/')
}
